import { Link } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';
import styles from './PrivacyNoticePage.module.css';

/**
 * The canonical policy for the whole of Chemical Dependency Lab.
 *
 * Loupe used to restate its own privacy terms here, which meant two documents
 * that could drift apart. This page now defers to the policy above and keeps
 * only the operational facts particular to this site.
 */
const MAIN_PRIVACY_POLICY = 'https://chemicaldependency.co.uk/policies/privacy-policy';

export function PrivacyNoticePage() {
  usePageTitle('Privacy notice');
  return (
    <main className={styles.page}>
      <h1 className={styles.heading}>Privacy Notice</h1>

      <section className={styles.section}>
        <p>
          Loupe is part of Chemical Dependency Lab, and our privacy policy covers
          it: what we collect, how we use it, who else handles it and what rights
          you have over it.
        </p>
        <p>
          <a
            href={MAIN_PRIVACY_POLICY}
            target="_blank"
            rel="noopener noreferrer"
          >
            Read the Chemical Dependency Lab privacy policy
          </a>
        </p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionHeading}>Specific to Loupe</h2>
        <ul className={styles.list}>
          <li>
            <strong>Scan retention.</strong> Your scan files stay available for
            one year from the date they become ready, then they are permanently
            deleted. Download anything you want to keep before then, or order
            prints.
          </li>
          <li>
            <strong>Cookies.</strong> Signing in sets a single strictly necessary
            session cookie, and nothing else. See our{' '}
            <Link to="/cookie-policy">Cookie Policy</Link> for the full details.
          </li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionHeading}>Questions</h2>
        <p>
          If you have questions about your data or want something removed, get in
          touch with us directly. You know where to find us.
        </p>
      </section>
    </main>
  );
}
